import { useState } from 'react';
import './App.css';
import Navbar from './components/Navbar';
import TextForm from './components/TextForm';
import Alert from './components/Alert';
import About from './components/About';
import {
  BrowserRouter as Router,
  Switch,
  Route
} from "react-router-dom";

function App() {
  const [mode, setmode] = useState("light")
  const [alert, setalert] = useState(null)

  const showalert = (message, type)=>{
    setalert({
      msg: message,
      typ: type
    })
    setTimeout(() => {
      setalert(null);
    }, 2000);
  }

  const togglemode = ()=>{
    if(mode === "light"){
      setmode("dark");
      document.body.style.backgroundColor = "#042743";
      showalert("Dark mode has been enabled!", "Success");
    }else{
      setmode("light");
      document.body.style.backgroundColor = "white";
      showalert("Light mode has been enabled!", "Success");
    }
  }

  return (
    <>
      <Router>
        <Navbar title="TextEditor" mode={mode} togglemode={togglemode}/>
        <Alert alert={alert}/>
        <div className="container">
          <Switch>
            <Route path="/About">
              <About mode={mode}/>
            </Route>
            <Route path="/">
              <TextForm heading="Enter your text below" mode={mode}/>
            </Route>
          </Switch>
        </div>
      </Router>
    </>
  );
}

export default App;
